import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vip-card"
}
const _hoisted_2 = { class: "vip-body" }
const _hoisted_3 = { class: "vip-section" }
const _hoisted_4 = { class: "vip-values" }
const _hoisted_5 = { style: {"color":"#ffa4d1","font-size":"11px"} }
const _hoisted_6 = { class: "bar" }
const _hoisted_7 = { class: "vip-values-bottom" }

import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'vipCard',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)

const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_unref(userStore).vipAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "12",
              class: "vip-title"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createTextVNode(" VIP ")),
                _createElementVNode("span", null, _toDisplayString(currentLevel.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "vip-link",
              onClick: onClickCard
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.verMais')) + " ", 1),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "20",
                  style: {"padding-left":"10px"}
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('profile.volumeAcumulado')), 1),
              _createElementVNode("span", null, _toDisplayString(betTotal.value), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "progress",
                style: _normalizeStyle({ width: betTotal.value / betMin.value < 1 ? (betTotal.value * 100) / betMin.value + '%' : '100%' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { style: {"color":"#FFFFFF73"} }, "0", -1)),
              _createElementVNode("span", null, _toDisplayString(betMin.value) + " (VIP " + _toDisplayString(nextLevel.value) + ")", 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})